export default {
  "content": "<path d=\"M22.05 19.2c-.93-.69-2.47-6.1-3.42-12a6.78 6.78 0 00-5.12-4.92 1.49 1.49 0 00-2.91-.13 6.91 6.91 0 00-5.83 5.32C4.15 13.2 2.89 18.5 2 19.2A.9.9 0 102 21h7.17a3 3 0 005.66 0h7.22a.9.9 0 100-1.79v-.01zm-7.34-6.49l-4 4a1.002 1.002 0 01-1.639-.326 1 1 0 01.219-1.094l2.3-2.29H9a1 1 0 01-.92-.62 1 1 0 01.21-1.09l4-4a1.004 1.004 0 111.42 1.42L11.41 11H14a1 1 0 01.92.62 1 1 0 01-.21 1.09z\" fill=\"#3F4450\"/>",
  "attrs": {
    "width": "24",
    "height": "24",
    "fill": "none",
    "xmlns": "http://www.w3.org/2000/svg",
    "viewBox": "0 0 24 24"
  }
};